import * as React from "react"

interface RadioButtonProps {
  id: string
  name: string
  checked: boolean
  onChange: () => void
  children: React.ReactNode
}

export const RadioButton: React.FC<RadioButtonProps> = ({
  id,
  name,
  checked,
  onChange,
  children
}) => {
  return (
    <div className="flex items-center gap-2">
      <input
        type="radio"
        id={id}
        name={name}
        checked={checked}
        onChange={onChange}
        className="w-4 h-4 border rounded-full appearance-none cursor-pointer bg-transparent border-zinc-800 checked:border-zinc-800 dark:border-white dark:checked:border-white checked:relative checked:after:content-[''] checked:after:absolute checked:after:top-1/2 checked:after:left-1/2 checked:after:transform checked:after:-translate-x-1/2 checked:after:-translate-y-1/2 checked:after:w-2 checked:after:h-2 checked:after:rounded-full checked:after:bg-zinc-900 dark:checked:after:bg-white"
      />
      <label htmlFor={id} className="cursor-pointer flex flex-row gap-2 items-center">
        {children}
      </label>
    </div>
  )
}